import {ZOOMTO} from './ZoomToTypes'

export const selectNodes = nodesTo => {
    return {
        type: ZOOMTO,
        load: nodesTo
    }
}

// export const selectCheckBox = (checkBox) => {

//     return (dispatch) => {
//         dispatch(changeCheckBox(checkBox))
//     }

// }